<ion-header class="extendido" *ngIf="loaded">
  <ion-buttons>
    <ion-button (click)="closeModal()">
      <i class="fa-regular fa-chevron-left chevron-back-button"></i>
    </ion-button>

    <ion-title class="ion-title-icon">{{'Notificações' | translate}}</ion-title>

    <ion-col *ngIf="notifications.length" class="end-filter" (click)="updateAll()">
      <i class="fas fa-ellipsis-v"></i>
    </ion-col>
  </ion-buttons>
</ion-header>

<app-loading-spinner *ngIf="!loaded"></app-loading-spinner>

<ion-content *ngIf="loaded">
  <div class="gradient-extendido"></div>

  <ion-card-content class="card-content">
    <div *ngIf="notifications.length">
      <ion-item-sliding *ngFor="let notification of notifications">
        <ion-item>
          <ion-grid>
            <ion-row>
              <ion-col size="2" class="box-container">
                <span class="box" *ngIf="!notification.dataLido">
                  <i class="fas fa-envelope"></i>
                </span>

                <span class="box open-color" *ngIf="notification.dataLido" >
                  <i class="fas fa-envelope-open"></i>
                </span>
              </ion-col>

              <ion-col size="10" (click)="leitura(notification)">
                <div>
                  <p class="bold-1 description-title">{{notification.title | translate}}</p>
                  <p class="description bold-1">{{notification.message}}</p>
                  <p class="description bold-1">
                    {{notification.dataEnvio | dateFormat:'dd'}} {{notification.dataEnvio |
                    dateFormat:'MMMM'}} {{'de' | translate}} {{notification.dataEnvio |
                    dateFormat:'Y'}}
                  </p>
                </div>
              </ion-col>
            </ion-row>
          </ion-grid>
        </ion-item>

        <ion-item-options side="end">
          <ion-item-option color="danger" expandable (click)="alert(notification)" style="padding: 15px;">
            <i class="far fa-trash-alt danger"></i>
          </ion-item-option>
        </ion-item-options>
      </ion-item-sliding>
    </div>

    <div *ngIf="!notifications.length && loaded" class="notification">
      <sem-registro [text]="'Nenhuma notificação localizada.'"></sem-registro>
    </div>
  </ion-card-content>
</ion-content>